import React from 'react';
import { Button } from "react-bootstrap";
import { createPortal } from 'react-dom';
import useConfirm from './hooks/useConfirm';

const ConfirmDialog = () => {
    const { onConfirm, onCancel, confirmState } = useConfirm();

    const portalElement = document.getElementById('portal');
    const component = confirmState.show ? (
        <div className="portal-overlay">
            <div className="confirm-dialog">
                <h4 className="card-title">{confirmState?.text && confirmState.text}</h4>
                <div className="confirm-dialog__footer">
                    <Button variant="primary"
                        style={{ marginRight: 4, minWidth: 80 }}
                        onClick={onConfirm}>
                        SIM
                    </Button>
                    <Button variant="secondary"
                        style={{ marginLeft: 4, minWidth: 80 }}
                        onClick={onCancel}>
                        NÃO
                    </Button>
                </div>
            </div>
        </div>
    ) : null;

    return createPortal(component, portalElement);
};
export default ConfirmDialog;